import { NumberInput } from "@/components/ui/input";

export function MoneyInput({
  value,
  onValueChange,
  disabled,
  required,
  name,
  placeholder,
  id,
  min,
  max,
  defaultValue,
  className,
}: {
  defaultValue?: number;
  min?: number;
  max?: number;
  value?: number;
  onValueChange?: (value: number) => void;
  disabled?: boolean;
  required?: boolean;
  name?: string;
  placeholder?: string;
  id?: string;
  className?: string;
}) {
  return (
    <NumberInput
      id={id}
      name={name}
      placeholder={placeholder}
      min={min ?? 0}
      max={max ?? 10000}
      step={0.01}
      defaultValue={defaultValue}
      value={value}
      isRequired={required}
      onValueChange={onValueChange}
      isDisabled={disabled}
      formatOptions={{
        style: "currency",
        currency: "USD",
      }}
      className={className}
    />
  );
}
